import { Routes, Route, Navigate } from "react-router-dom";
import Monitoring from "./Modules/Monitoring";
import History from "./Modules/MonitoringTrips";
import MonitoringTrips from "pages/Planning/Modules/MonitoringTrips";
import RestrictionRoute from "routes/RestrictionRoute";
import AppointmentReport from "pages/Planning/Modules/AppointmentReport";
import PlanningAssiggnment2 from "pages/Planning/Modules/PlanningAssiggnment2";
import CostReport from "pages/Planning/Modules/CostReport";

const RouterMonitoring = ({ views }) => {
  return (
    <Routes>
      <Route
        path="/maps"
        element={
          <RestrictionRoute views={views}>
            <Monitoring />
          </RestrictionRoute>
        }
      />
      <Route
        path="/monitoring-trips"
        element={
          <RestrictionRoute views={views}>
            <MonitoringTrips />
          </RestrictionRoute>
        }
      />
      <Route
        path="load-plan-assignment"
        element={
          <RestrictionRoute views={views}>
            <PlanningAssiggnment2 />
          </RestrictionRoute>
        }
      />
      <Route
        path="monitoring-history"
        element={
          <RestrictionRoute views={views}>
            <History />
          </RestrictionRoute>
        }
      />
      <Route
        path="dating-history"
        element={
          <RestrictionRoute views={views}>
            <AppointmentReport />
          </RestrictionRoute>
        }
      />
      <Route
        path="cost-report"
        element={
          <RestrictionRoute views={views}>
            <CostReport />
          </RestrictionRoute>
        }
      />
      <Route path="*" element={<Navigate to="../maps" replace />} />
    </Routes>
  );
};

export default RouterMonitoring;
